import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import { HAIR_COLOR_LIST, HAIR_COLOR_NO_CHANGE } from '../../../../config/dataConfig/FJHairstyleChangerDataConfig';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJConfig from '../../../../config/FJConfig';
import FJModalItem from '../../../../common/components/FJModalItem/FJModalItem';
import NoChange from '../../../../assets/svg/no-change.svg?react';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip';
import FJTextWithEllipsisParent from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsisParent';

import styles from './FJHairColorList.module.less';

function FJHairColorList({ onChange, value }) {
    const scrollRef = useRef(null);

    // 当组件挂载或选中值变化时，滚动到选中的颜色元素
    useEffect(() => {
        if (!scrollRef.current || !value?.key) return;

        const selectedEl = document.getElementById(value.key);
        if (!selectedEl) return;

        const scrollToElement = () => {
            selectedEl.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        };

        // 立即滚动，延迟确保内容加载完成
        const timer = setTimeout(scrollToElement, 100);

        // 监听尺寸变化，必要时重新滚动
        const resizeObserver = new ResizeObserver(() => {
            scrollToElement();
        });

        // 观察滚动容器的高度变化
        if (scrollRef.current?.getScroller) {
            resizeObserver.observe(scrollRef.current.getScroller());
        }

        return () => {
            clearTimeout(timer);
            resizeObserver.disconnect();
        };
    }, [value?.key]);

    return (
        <div className={styles.box}>
            <FJVerticalScroller className={styles.scroll} ref={scrollRef}>
                {HAIR_COLOR_LIST?.length > 0 &&
                    HAIR_COLOR_LIST.map(item =>
                        item.value === HAIR_COLOR_NO_CHANGE ? (
                            <div className={styles.no_change_item_container} key={item.key}>
                                <FJHoverBoardGradation
                                    className={styles.hover_board_box}
                                    active={value?.key === item.key}
                                    borderRadius={6}
                                    isShowInBorder
                                >
                                    <FJToolTip title={FJLocalStore._(item.key)}>
                                        <div
                                            id={item.key}
                                            className={classNames(styles.color_item, styles.no_change_icon)}
                                            onClick={() => onChange(item)}
                                        >
                                            <NoChange />
                                        </div>
                                    </FJToolTip>
                                </FJHoverBoardGradation>
                                <FJTextWithEllipsisParent className={styles.name} text={FJLocalStore._(item.key)} />
                            </div>
                        ) : (
                            <FJModalItem
                                key={item.key}
                                id={item.key}
                                imgSrc={FJConfig.hairColorPath + item.filename + `?v=${FJConfig.version}`}
                                name={FJLocalStore._(item.key)}
                                selected={item.key === value?.key}
                                onClick={() => {
                                    onChange(item);
                                }}
                            />
                        ),
                    )}
            </FJVerticalScroller>
        </div>
    );
}

FJHairColorList.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.string,
        filename: PropTypes.string,
    }),
};

export default FJHairColorList;
